export const RETAILER_NAME = "Retailer name here";
export const DEFAULT_DEDUCTION = 26;
export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const FINANCIAL_YEAR_START_DATE = "01/04/2022";
export const EXPIRY_ALLOWED_IN_DAYS = 90;
export const MAX_RETURNABLE_QUANTITY = 99;
export const MAX_ALLOWABLE_DISCOUNT = 99.99;
export const MIN_BARCODE_LENGTH = 5;
export const MAX_ALLOWABLE_CDPER = 99.99;
export const PLAY_ALERT_SOUND_ON_ERROR = false;
export const MIN_EXPIRY_IN_MONTHS = 48;
export const SEARCH_BY_SALTS = true;
export const SEARCH_BY_MRP = true;
export const STOP_EXPIRY_PRODUCTS_SEARCH = true;
export const SALES_FOCUS_PATIENT = true;
export const SALES_EDIT_MRP = false;
export const IS_RETURN_ALLOWED_ON_SALES = false;
export const SUPPORT_EMAIL1 = "support@pharmacyapp.in";
export const SUPPORT_CONTACT1 = 8169415916;

export const getTabBadgeColor = (index) => {
  switch (index) {
    case 0:
      return { background: "#f24326", color: "white" };
    case 1:
      return { background: "#86ca9d" };
    case 2:
      return { background: "#9753fa", color: "white" };
    case 3:
      return { background: "#5693f0", color: "white" };
    default:
      return null;
  }
};
export const gstValues = [
  {
    id: 0,
    label: "0%",
  },
  {
    id: 5,
    label: "5%",
  },
  {
    id: 12,
    label: "12%",
  },
  {
    id: 18,
    label: "18%",
  },
  {
    id: 28,
    label: "28%",
  },
];
export const medicineCategories = [
  {
    id: "1",
    label: "MEDICINE",
  },
  {
    id: "2",
    label: "FMCG",
  },
  {
    id: "3",
    label: "SURGICAL",
  },
  {
    id: "4",
    label: "AYURVEDIC",
  },
  {
    id: "5",
    label: "GENERIC MEDICINE",
  },
  {
    id: "6",
    label: "HOMEOPATHY",
  },
  {
    id: "7",
    label: "OTHER",
  },
  {
    id: "8",
    label: "DIAGNOSTICS",
  },
];
export const medicineScheduleTypes = [
  {
    id: "-5",
    label: "NONE",
  },
  {
    id: "-1",
    label: "SCHEDULED H",
  },
  {
    id: "-2",
    label: "SCHEDULED H1",
  },
  {
    id: "-3",
    label: "NARCOTIC DRUG",
  },
  {
    id: "-4",
    label: "SCHEDULED X",
  },
];

export const therapeuticTypes = [
  {
    id: "ANTI INFECTIVE",
    label: "ANTI INFECTIVE",
  },
  {
    id: "ANTIPARASITIC",
    label: "ANTIPARASITIC",
  },
  {
    id: "ANTIVIRAL",
    label: "ANTIVIRAL",
  },
  {
    id: "BLOOD PRESSURE",
    label: "BLOOD PRESSURE",
  },
  {
    id: "CANCER / CARCINOGENIC",
    label: "CANCER / CARCINOGENIC",
  },
  {
    id: "CARDIAC",
    label: "CARDIAC",
  },
  {
    id: "COVID",
    label: "COVID",
  },
  {
    id: "DERMATOLOGICAL",
    label: "DERMATOLOGICAL",
  },
  {
    id: "DIABETES",
    label: "DIABETES",
  },
  {
    id: "GASTROINTESTINAL",
    label: "GASTROINTESTINAL",
  },
  {
    id: "GYNAECOLOGY",
    label: "GYNAECOLOGY",
  },
  {
    id: "HEPATOLOGY",
    label: "HEPATOLOGY",
  },
  {
    id: "HORMONES",
    label: "HORMONES",
  },
  {
    id: "NERVOUS SYSTEM",
    label: "NERVOUS SYSTEM",
  },
  {
    id: "ONCOLOGY & IMMUNOLOGY",
    label: "ONCOLOGY & IMMUNOLOGY",
  },
  {
    id: "OPHTHALMOLOGY/OTOLOGY",
    label: "OPHTHALMOLOGY/OTOLOGY",
  },
  {
    id: "OTHERS",
    label: "OTHERS",
  },
  {
    id: "PAIN MANAGEMENT",
    label: "PAIN MANAGEMENT",
  },
  {
    id: "RESPIRATORY",
    label: "RESPIRATORY",
  },
  {
    id: "STOMATOLOGICAL",
    label: "STOMATOLOGICAL",
  },
  {
    id: "THYROID",
    label: "THYROID",
  },
  {
    id: "UROLOGY",
    label: "UROLOGY",
  },
  {
    id: "VACCINES",
    label: "VACCINES",
  },
  {
    id: "VITAMINS & NUTRITIONAL SUPPLEMENTS",
    label: "VITAMINS & NUTRITIONAL SUPPLEMENTS",
  },
];
export const stateCodes = [
  { label: "1 - JAMMU & KASHMIR", id: "1 - JAMMU & KASHMIR" },
  { label: "2 - HIMACHAL PRADESH", id: "2 - HIMACHAL PRADESH" },
  { label: "3 - PUNJAB", id: "3 - PUNJAB" },
  { label: "4 - CHANDIGARH", id: "4 - CHANDIGARH" },
  { label: "5 - UTTARAKHAND", id: "5 - UTTARAKHAND" },
  { label: "6 - HARYANA", id: "6 - HARYANA" },
  { label: "7 - DELHI", id: "7 - DELHI" },
  { label: "8 - RAJASTHAN", id: "8 - RAJASTHAN" },
  { label: "9 - UTTAR PRADESH PRADESH", id: "9 - UTTAR PRADESH" },
  { label: "10 - BIHAR", id: "10 - BIHAR" },
  { label: "11 - SIKKIM", id: "11 - SIKKIM" },
  { label: "12 - ARUNACHAL PRADESH", id: "12 - ARUNACHAL PRADESH" },
  { label: "13 - NAGALAND", id: "13 - NAGALAND" },
  { label: "14 - MANIPUR", id: "14 - MANIPUR" },
  { label: "15 - MIZORAM", id: "15 - MIZORAM" },
  { label: "16 - TRIPURA", id: "16 - TRIPURA" },
  { label: "17 - MEGHLAYA", id: "17 - MEGHLAYA" },
  { label: "18 - ASSAM", id: "18 - ASSAM" },
  { label: "19 - WEST BENGAL", id: "19 - WEST BENGAL" },
  { label: "20 - JHARKHAND", id: "20 - JHARKHAND" },
  { label: "21 - ODISHA", id: "21 - ODISHA" },
  { label: "22 - CHATTISGARH", id: "22 - CHATTISGARH" },
  { label: "23 - MADHYA PRADESH", id: "23 - MADHYA PRADESH" },
  { label: "24 - GUJARAT", id: "24 - GUJARAT" },
  { label: "25 - DAMAN AND DIU", id: "25 - DAMAN AND DIU" },
  { label: "26 - DADRA AND NAGAR HAVELI", id: "26 - DADRA AND NAGAR HAVELI" },
  { label: "27 - MAHARASHTRA", id: "27 - MAHARASHTRA" },
  {
    label: "28 - ANDHRA PRADESH (BEFORE DIVISION)",
    id: "28 - ANDHRA PRADESH (BEFORE DIVISION)",
  },
  { label: "29 - KARNATAKA", id: "29 - KARNATAKA" },
  { label: "30 - GOA", id: "30-GOA" },
  { label: "31 - LAKSHWADEEP", id: "31 - LAKSHWADEEP" },
  { label: "32 - KERALA", id: "32 - KERALA" },
  { label: "33 - TAMIL NADU", id: "33 - TAMIL NADU" },
  { label: "34 - PUDUCHERRY", id: "34 - PUDUCHERRY" },
  {
    label: "35 - ANDAMAN AND NICOBAR ISLANDS",
    id: "35 - ANDAMAN AND NICOBAR ISLANDS",
  },
  { label: "36 - TELANGANA", id: "36 - TELANGANA" },
  { label: "37 - ANDHRA PRADESH (NEW)", id: "37 - ANDHRA PRADESH (NEW)" },
];
